import assetUtils, { Asset } from 'app-lib/assetUtils'
import providerUtils from 'app-lib/providerUtils'
import { chainConfigs, getBlockExplorerAddressLink } from 'bzx-common/src/config/appConfig'
import { migrationList } from 'bzx-common/src/services/MigrateService'
import { MigrationStore, RootStore } from 'bzx-common/src/stores'
import { Migration } from 'bzx-common/src/stores/MigrationStore'
import * as mobx from 'mobx'

export default class MigrateTokensVM {
  rootStore: RootStore
  migrationStore: MigrationStore

  get ookiInfo() {
    const migrationDetails = migrationList.BZRX_TO_OOKI
    return migrationDetails.chainsAvailable.map((chainId) => {
      const info = assetUtils.getInfo(chainId, Asset.OOKI)
      const converterAddress = migrationDetails.chains[chainId]?.converterAddress || ''
      return {
        ...info,
        chainId,
        chainIcon: chainConfigs[chainId].icon,
        ookiExplorerLink: getBlockExplorerAddressLink(chainId, info.address),
        converterAddress,
        converterExplorerLink: getBlockExplorerAddressLink(chainId, converterAddress),
      }
    })
  }

  addOokiToken() {
    const { chainId } = this.rootStore.web3Connection
    if (chainId === 1 || chainId === 137) {
      providerUtils.addToken(chainId, Asset.OOKI)
    }
  }

  init() {
    setTimeout(() => {
      this.migrationStore.set('autoSyncData', true)
    }, 0)
  }

  destroyVM() {
    this.migrationStore.autoSyncData = false
  }

  convert(migration: Migration) {
    migration.convert()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    this.migrationStore = rootStore.migrationStore
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
    this.init()
  }
}
